import '../css/contact.css'

import React from 'react';

function Contact() {
  return (
    <article className="sectionBackgroundWhit">
      <h1>Entre em Contato</h1>
      <p>Carmo do Cajuru, MG - Brasil</p>
      <p>arthurmcorrea282@gmail.com</p>
      <p>Tel: (37) 999480917</p>
    </article>
  );
}

export default Contact;
